import React from 'react';
import { useTailwindBrand } from '../shared';
import { ENV_DECLARONS, isBrandActive } from '../../config/environment.config';

interface FormSeparator {
    children : string
    className?: string
}

const FormSeparator = ({children, className} : FormSeparator) => {
    const { classes, brandConfig } = useTailwindBrand()
    return (

        <div className={`${className} flex-shrink-0 bg-transparent`}>
            <div
                className={`flex items-center justify-center gap-3 md:gap-4 ${classes.fontFamily}`}
            >
                <hr
                    className="relative overflow-hidden p-[1px] flex-shrink-0 flex-1 h-px border-2 border-transparent rounded-full"
                    style={{ background: `linear-gradient(135deg, ${brandConfig.colors?.primary} 0%, ${brandConfig.colors?.primary}F2 60%, ${brandConfig.colors?.primary}D9 70%)` }}
                />
                {/* <hr
                    className={`flex-1 h-px border-2 border-transparent ${classes.primaryBorder}`}
                    /> */}
                <span
                    className={`text-xs md:text-sm font-bold whitespace-nowrap px-2 md:px-4 text-gray-600 ${classes.fontFamily}`}
                >
                    {children}
                </span>
                    <hr
                        className="relative overflow-hidden p-[1px] flex-shrink-0 flex-1 h-px border-2 border-transparent rounded-full"
                        style={{ background: `linear-gradient(135deg, ${brandConfig.colors?.primary} 0%, ${brandConfig.colors?.primary}F2 60%, ${brandConfig.colors?.primary}D9 70%)` }}
                    />
                {/* <hr
                    className={`flex-1 h-px border-2 border-transparent ${classes.primaryBorder}`}
                /> */}
            </div>
        </div>
    );
};

export default FormSeparator;